export const getAuth0Email = (auth0User: any): string | null => {
  if (!auth0User) {
    return null;
  }

  if (auth0User.email) {
    return auth0User.email;
  }

  return null;
};


export const isValidEmail = (email: string | null | undefined): email is string => {
  if (!email || typeof email !== 'string') {
    return false;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};


export const getPreferredEmail = (
  auth0User: any,
  backendEmail: string | null | undefined
): string | null => {
  const auth0Email = getAuth0Email(auth0User);
  if (isValidEmail(auth0Email)) {
    return auth0Email;
  }

  if (isValidEmail(backendEmail)) {
    return backendEmail;
  }

  return null;
};

export const getAuth0Names = (auth0User: any) => {
  if (!auth0User) {
    return { name: null, nickname: null, givenName: null, familyName: null };
  }

  return {
    name: auth0User.name || null,
    nickname: auth0User.nickname || null,
    givenName: auth0User.given_name || null,
    familyName: auth0User.family_name || null,
  };
};

export const extractAuth0UserInfo = (auth0User: any) => {
  if (!auth0User) {
    return {
      email: null,
      name: null,
      nickname: null,
      givenName: null,
      familyName: null,
      sub: null,
      picture: null,
    };
  }

  return {
    email: auth0User.email || null,
    name: auth0User.name || null,
    nickname: auth0User.nickname || null,
    givenName: auth0User.given_name || null,
    familyName: auth0User.family_name || null,
    sub: auth0User.sub || null,
    picture: auth0User.picture || null,
  };
};
